import { lazy } from 'react';

export const RegistrationStepperAsync = lazy(() =>
  import('./RegistrationStepper').then((m) => ({ default: m.RegistrationStepper })),
);
